/* eslint-disable camelcase */

import removeTrailingPeriodStringUtil from 'utils/string/remove-trailing-period'

/**
 * @param {ProductVariantCollection} productVariant
 */
const getSizeGuideProductVariantUtil = ({ productVariant }) => {
  const sizeGuide = (
    productVariant?.size_option ??
    ''
  )

  return removeTrailingPeriodStringUtil(sizeGuide)
}

export default getSizeGuideProductVariantUtil
